/**
    @description  核心类库
    @create       2019-11-20 22:27"
    @remark       api设计基于lodash  中文官网 https://www.lodashjs.com/docs/latest  
    @remark       开发文档  https://job.xrdev.cn/docs/
*/

import * as fn from "./function/index"

export * from "./function/index"

export default {
    ...fn
};







